import Api from '../../library/api';

export const REQUEST_PAST_BOOKINGS = 'REQUEST_PAST_BOOKINGS';
export const SET_PAST_BOOKINGS = 'SET_PAST_BOOKINGS';

export function getPastBookings() {
  return dispatch => {

    dispatch({type: REQUEST_PAST_BOOKINGS});

    Api.post('p/job-summaries', { filter: 'Current' })
      .then(resp => {

        dispatch({
          type: SET_PAST_BOOKINGS,
          payload: resp.journeyReports
        })

      })

  }
}


// WEBPACK FOOTER //
// ./src/components/past-bookings/past-bookings-actions.js